import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export const MLoadingScreen = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        height: '90%',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <CircularProgress color="secondary" />
    </Box>
  );
};
